import React from "react";
import {Route, Switch} from "react-router-dom";
import KinerjaKeuangan from "pages/UserDireksi/Index";

const UserDireksi = ({match}) => (
  <Switch>
    <Route path={`${match.url}/kinerja-keuangan`} component={KinerjaKeuangan}/>
  </Switch>
);

export default UserDireksi;
